import { all, put, takeLatest } from 'redux-saga/effects';
import {
  multipleLanguageFailure,
  multipleLanguageRequest,
  multipleLanguageSuccess,
} from './actions';
import { LanguageTypes } from './types';

function* multipleLanguage({
  payload,
}: ReturnType<typeof multipleLanguageRequest>) {
  const ptbr = {
    login: {
      fazerLogon: 'Fazer login',
      paisEmpresa: 'Controlador',
      categoria: 'Categoria',
      chaveDeIdentificacao: 'CPF',
      continuar: 'Continuar',
      bemVindo: 'Bem-vindo',
      LGPDSystem: 'Portal LGPD',
      solicitarAjudaAoDPO: 'Solicitar Ajuda ao DPO',
      sugestaoDeUsoLogin: {
        parte_1:
          'Este computador não é seu? Utilize o modo convidado para iniciar sessão de forma privada.',
        parte_2: 'Saiba mais',
      },
      politicaGoogle: {
        parte_1: 'Protegido por reCAPTCHA e sujeito à',
        parte_2: 'Política de privacidade',
        parte_3: 'e aos',
        parte_4: 'Termos de serviço',
        parte_5: 'do Google.',
      },
      solicitarSenha: 'Solicitar Senha',
      FAQ: 'FAQ',
      escolhaUmEmailParaReceberASenha:
        'Por favor, escolha um e-mail para receber a senha.',
      voceNãoTemEmailCadastrado:
        'Não será possível prosseguir com a solicitação. Por favor, entre em contato com o DPO.',
      facaLoginEmUmaContaDiferente: 'Fazer login em uma conta diferente',
      insiraSuaSenha: 'Insira sua senha',
      senha: 'Senha',
      naoRecebiMinhaSenhaEnviarNovamente:
        'Não recebi minha senha enviar novamente?',
      paraContinuarValidePrimeiroASuaIdentidade:
        'Para continuar, valide primeiro a sua identidade',
    },
    solicitarAjudaAoDPO: {
      solicitarAjudaAoDPO: 'Solicitar ajuda ao DPO',
      chaveDeIdentificacao: 'CPF',
      enderecoDeEmail: 'Endereço de E-mail',
      redigiteOEnderecoDeEmail: 'Redigite o endereço de E-mail',
      categoria: 'Categoria',
      assunto: 'Assunto',
      descricaoDaSolicitacao: 'Descrição da solicitação',
      enviar: 'Enviar',
      fazerLogin: 'Fazer login',
      ajuda: 'Ajuda',
      FAQ: 'FAQ',
      politicaGoogle: {
        parte_1: 'Protegido por reCAPTCHA e sujeito à',
        parte_2: 'Política de privacidade',
        parte_3: 'e aos',
        parte_4: 'Termos de serviço',
        parte_5: 'do Google.',
      },
    },
    gerenciarConsentimento: {
      gerenciarConsentimento: 'Gerenciar consentimento',
      paisEmpresa: 'Controlador',
      categoria: 'Categoria',
      chaveDeIdentificacao: 'CPF',
      escolhaAsAtividadesQueVoceAutoriza:
        'Escolha as atividades que você autoriza a empresa a usar para sua operação',
      codigo: 'Código',
      atividade: 'Atividade',
      linhasPorPagina: 'Linhas por página',
      ajuda: 'Ajuda',
      salvar: 'Salvar',
    },
  };
  const enus = {
    login: {
      title: 'Fazer logon',
      input: {
        placeholder: {
          countryCompany: 'empresa do país',
          ownershipType: 'Ownership Type',
          identificationKey: 'Identification Key',
        },
        label: {
          countryCompany: 'empresa do país',
          ownershipType: 'Ownership Type',
          identificationKey: 'Identification Key',
        },
      },
      button: {
        continue: 'continue',
      },
      others: {
        Welcome: 'Welcome',
        option1:
          'Este computador não é seu? Utilize o modo convidado para iniciar sessão de forma privada.<> Saiba mais</>',
        talkToDPO: 'Solicitar Ajuda ao DPO',
      },
    },
  };

  try {
    const { language } = payload;

    let select: any;

    switch (language) {
      case 'ptbr':
        select = ptbr;
        break;
      case 'enus':
        select = enus;
        break;

      default:
        break;
    }

    yield put(multipleLanguageSuccess(select));
  } catch (error) {
    yield put(multipleLanguageFailure());
  }
}

export default all([
  takeLatest(LanguageTypes.MULTIPLE_LANGUAGE_RESQUEST, multipleLanguage),
]);
